import React, {FC} from 'react'

type LoaderSectionProps = {
  height?: number | string
}

export const LoaderSection: FC<LoaderSectionProps> = ({height = "100vh"}) => {
  return (
      <div className={"d-flex align-items-center justify-content-center"} style={{
        height: height
      }}>
        <div>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Yuklanmoqda...</span>
          </div>
        </div>
      </div>
  )
}
